import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import { format } from "date-fns";
import React, { Fragment, useRef, useState } from "react";
import {
  deleteSoloEvent,
  deleteThisEvent,
} from "../../../Calendar/calendarFunctions";
import { baseUrl } from "../../../assets/Animations";

export default function TeacherCancellationForm({
  event,
  abortCancellationFlow,
  setAllEvents,
  setOpenEvent,
  socket,
  setEditing,
}) {
  const [open, setOpen] = useState(true);
  const [teacherCancelled, setTeacherCancelled] = React.useState(true);
  const [twentyFourHours, setTwentyFourHours] = React.useState(false);
  const [chargeTheFamily, setChargeTheFamily] = React.useState(false);
  const [reasonForCancellation, setReasonForCancellation] = React.useState("");

  const myToken = localStorage.getItem("token");
  const myHeader = { headers: { Authorization: `Bearer ${myToken}` } };

  const cancelButtonRef = useRef(null);

  console.log(setOpenEvent);

  const submitTeacherCancellationForm = async () => {
    // console.log('submitTeacherCancellationForm')
    // console.log('whoCancelled', teacherCancelled)
    // console.log('twentyFourHours', twentyFourHours)
    // console.log('chargeTheFamily', chargeTheFamily)
    // console.log('reasonForCancellation', reasonForCancellation)
    axios
      .post(`${baseUrl}/cancellation`, {
        event: {
          ...event,
          teacherCancelled: teacherCancelled,
          lessThan24Hours: twentyFourHours,
          chargedTheFamily: chargeTheFamily,
          reason: reasonForCancellation,
        },
      })
      .then((res) => {
        //console.log(res.data)
      })
      .catch((err) => console.log(err));
    if (event.recurring.isOn) {
      await deleteThisEvent(
        event,
        event.dateTime,
        setAllEvents,
        setOpenEvent,
        socket,
        event.teacherName,
        myHeader
      );
    } else {
      await deleteSoloEvent(
        event,
        setAllEvents,
        setOpenEvent,
        socket,
        event.teacherName
      );
    }
    //AUTO EMAIL TO FAMILY
    //AUTO EMAIL TO TEACHER
    //AUTO EMAIL TO ADMIN
    //AUTO SLACK NOTIFICATION TO ADMIN
  };

  const rescheduleInstead = () => {
    abortCancellationFlow(false);
    setEditing(true);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-30 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Cancellation Form - {event.teacherName}
                    </Dialog.Title>
                    <div className="mb-5 text-left">
                      <label
                        htmlFor="student-name"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Student
                      </label>
                      <p className="text-sm text-gray-500 inline-block my-1 mr-5 border-solid border border-gray-300 px-2 py-1 rounded-md">
                        {event.studentName} {event.familyName}
                      </p>
                      <p className="text-sm text-gray-500 inline-block my-1 mr-5 border-solid border border-gray-300 px-2 py-1 rounded-md">
                        {format(new Date(event.dateTime), "MMM/dd/yyyy")}{" "}
                        {format(new Date(event.dateTime), "h:mm a")}
                      </p>
                    </div>
                    <div className="mb-5 text-left">
                      <label
                        htmlFor="who-cancelled"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Who cancelled this lesson?
                      </label>
                      <fieldset
                        value={teacherCancelled}
                        onChange={(e) =>
                          setTeacherCancelled(
                            e.target.value === "true" ? true : false
                          )
                        }
                        className="mt-0 border-none"
                      >
                        <legend className="sr-only">Notification method</legend>
                        <div className="space-y-2">
                          <div className="flex items-left">
                            <input
                              id={"teacher-cancelled"}
                              name="notification-method"
                              type="radio"
                              value={true}
                              defaultChecked
                              className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                            />
                            <label
                              htmlFor={"teacher-cancelled"}
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              I'm cancelling this lesson
                            </label>
                          </div>
                          <div className="flex items-left">
                            <input
                              id={"family-cancelled"}
                              name="notification-method"
                              type="radio"
                              value={false}
                              className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                            />
                            <label
                              htmlFor={"family-cancelled"}
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              The family cancelled this lesson
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                    {!teacherCancelled && (
                      <div className="mb-5 text-left">
                        <label
                          htmlFor="who-cancelled"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Were you given 24 hours notice?
                        </label>
                        <div>
                          <fieldset
                            value={twentyFourHours}
                            onChange={(e) =>
                              setTwentyFourHours(
                                e.target.value === "true" ? true : false
                              )
                            }
                            className="mt-0 border-none"
                          >
                            <legend className="sr-only">
                              24 Hours Cancellation
                            </legend>
                            <div className="space-y-2">
                              <div className="flex items-left">
                                <input
                                  id={"less-than-24"}
                                  name="twenty-four-method"
                                  type="radio"
                                  value={true}
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label
                                  htmlFor={"less-than-24"}
                                  className="ml-3 block text-sm font-medium text-gray-700"
                                >
                                  No, less than 24 hours notice
                                </label>
                              </div>
                              <div className="flex items-left">
                                <input
                                  id={"more-than-24"}
                                  name="twenty-four-method"
                                  type="radio"
                                  value={false}
                                  defaultChecked
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label
                                  htmlFor={"more-than-24"}
                                  className="ml-3 block text-sm font-medium text-gray-700"
                                >
                                  Yes, more than 24 hours notice
                                </label>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    )}
                    {twentyFourHours && (
                      <div className="text-left">
                        <label
                          htmlFor="do-you-want-to-charge"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Do you want to charge the family for this lesson?
                        </label>
                        <div>
                          <fieldset
                            value={chargeTheFamily}
                            onChange={(e) =>
                              setChargeTheFamily(
                                e.target.value === "true" ? true : false
                              )
                            }
                            className="mt-0 border-none"
                          >
                            <legend className="sr-only">
                              24 Hours Cancellation
                            </legend>
                            <div className="space-y-2">
                              <div className="flex items-left">
                                <input
                                  id={"dont-charge"}
                                  name="do-you-want-to-charge"
                                  type="radio"
                                  value={false}
                                  defaultChecked
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label
                                  htmlFor={"dont-charge"}
                                  className="ml-3 block text-sm font-medium text-gray-700"
                                >
                                  No
                                </label>
                              </div>
                              <div className="flex items-left">
                                <input
                                  id={"yes-charge"}
                                  name="do-you-want-to-charge"
                                  type="radio"
                                  value={true}
                                  className="h-4 w-4 border-gray-300 border-solid text-indigo-600 focus:ring-indigo-500"
                                />
                                <label
                                  htmlFor={"yes-charge"}
                                  className="ml-3 block text-sm font-medium text-gray-700"
                                >
                                  Yes
                                </label>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    )}
                    <div className="mt-2">
                      <label
                        htmlFor="reason-for-cancellation"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Reason for cancellation
                      </label>
                      <div className="mt-2">
                        <textarea
                          id="reason-for-cancellation"
                          name="reason-for-cancellation"
                          rows={3}
                          className="block w-11/12 rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6"
                          onChange={(e) =>
                            setReasonForCancellation(e.target.value)
                          }
                          value={reasonForCancellation}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    onClick={() => submitTeacherCancellationForm()}
                  >
                    Submit Cancellation
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => rescheduleInstead()}
                    ref={cancelButtonRef}
                  >
                    Reschedule Lesson
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
